const Joi = require('joi');

const envVarsSchema = Joi.object()
  .keys({
    NODE_ENV: Joi.string().valid("production", "development", "demo", "test").required(),
    REACT_APP_API_URL: Joi.string()
      .default("")
      .description("backend server url different for each customer"),
    REACT_APP_STRIPE_PUBLIC_KEY: Joi.string().required().description("Stripe public key"),
    REACT_APP_USERS_PER_PAGE: Joi.number()
      .default(10)
      .description("number of users per page in users table"),
    REACT_APP_DOMAIN_NAME: Joi.string()
      .default("Fexo-Dev")
      .description("backend server url different for each customer"),
    REACT_APP_QUICK_BOOK_CLIENT_ID: Joi.string()
      .description("QuickBook client id")
      .required(),
    REACT_APP_QUICK_BOOK_REDIRECT_URI: Joi.string()
      .description("QuickBook redirect uri")
      .required(),
    REACT_APP_ZOHO_CLIENT_ID: Joi.string().description("ZohoBook client id").required(),
    REACT_APP_ZOHO_REDIRECT_URI: Joi.string()
      .description("ZohoBook redirect uri")
      .required(),
    REACT_APP_ZOHO_AUTH_URL: Joi.string().description("ZohoBook auth url").required(),
    REACT_APP_ZOHO_SCOPES: Joi.string()
      .description("ZohoBook Scopes")
      .default("ZohoBooks.fullaccess.all"),
    REACT_MAX_FILE_SIZE: Joi.number()
      .default(1024 * 50)
      .description("Max file size in kb"),
    REACT_APP_WHITE_LABEL: Joi.string()
      .default("Fexo")
      .description("White label name for the application"),
  })
  .unknown();

const { value: envVars, error } = envVarsSchema
  .prefs({ errors: { label: "key" } })
  .validate(process.env);

if (error) {
  throw new Error(`Config validation error: ${error.message}`);
}

export const config = {
  api: {
    url:
      envVars.NODE_ENV === "production"
        ? envVars.REACT_APP_API_URL
        : envVars.REACT_APP_API_URL,
  },
  stripe: {
    publicKey: envVars.REACT_APP_STRIPE_PUBLIC_KEY,
  },
  users: {
    resultsPerPage: envVars.REACT_APP_USERS_PER_PAGE,
  },
  domain: {
    name: envVars.REACT_APP_DOMAIN_NAME,
  },
  quick_config: {
    clientID: envVars.REACT_APP_QUICK_BOOK_CLIENT_ID,
    redirectURI: encodeURIComponent(envVars.REACT_APP_QUICK_BOOK_REDIRECT_URI),
  },
  zoho_config: {
    clientID: envVars.REACT_APP_ZOHO_CLIENT_ID,
    redirectURI: encodeURIComponent(envVars.REACT_APP_ZOHO_REDIRECT_URI),
    authURL: envVars.REACT_APP_ZOHO_AUTH_URL,
    scopes: envVars.REACT_APP_ZOHO_SCOPES,
  },
  maxFileSize: envVars.REACT_MAX_FILE_SIZE * 1024,
  whiteLabel: envVars.REACT_APP_WHITE_LABEL,
};
